import { getChatbotActionButtons } from './getChatbotActionButtons';
import { startPollingMessages } from './startPollingMessages';
import { trackApplyChatbotFilters } from './tracking';
import { closeChatbotFiltersModal, setFiltersLoading } from '../../actions/chatbotFiltersModal';
import { fetchSavePollAnswers, TSavePollAnswersResponse } from '../../repositories/cian-chat-bot/v1/save-poll-answers';
import { showAlert } from '../../slices/alertSlice';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { TThunkAction } from '../../types/redux/thunk';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';
import { getResponseError } from '../../utils/logging/getResponseError';

export const applyChatbotFilters =
  (jsonQuery: object): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger, config }) => {
    dispatch(setFiltersLoading(true));

    try {
      const { statusCode, response }: TSavePollAnswersResponse = await fetchSavePollAnswers({
        httpApi,
        parameters: { jsonQuery },
        config: { requestConfig: { withCredentials: true } },
      });

      dispatch(setFiltersLoading(false));

      /* istanbul ignore next */
      if (statusCode !== 200) {
        const exception = getResponseError({
          defaultMessage: 'Не удалось применить фильтры помогатора',
          response,
          domain: EExceptionDomain.Chatbot,
          details: {
            microserviceName: 'cian-chat-bot',
            pathApi: '/v1/save-poll-answers/',
            parameters: JSON.stringify(jsonQuery),
          },
          statusCode,
        });

        logger.warning(exception);

        dispatch(showAlert({ message: response.message || 'Возникла ошибка при попытке применить фильтры' }));

        return;
      }

      trackApplyChatbotFilters(jsonQuery);

      dispatch(startPollingMessages());

      const isChatbotGPTEnabled = config.get<boolean>('frontend-chats.chatbotGPT.Enabled') || false;

      /* istanbul ignore next */
      if (isChatbotGPTEnabled) {
        const {
          chatbot: { actionButtons },
        } = getState();

        const { payload, inputText } = actionButtons.find(
          ({ actionType, link }) => actionType === 'deeplink' && link?.includes('chat-bot-profiling'),
        ) || { payload: 'initial' };
        dispatch(getChatbotActionButtons(payload, inputText ?? undefined));
      }

      dispatch(closeChatbotFiltersModal());
    } catch (error) {
      const errorToLog = getGenericLikeError({
        error,
        domain: EExceptionDomain.Chatbot,
        message: 'Ошибка при попытке применить фильтры помогатора',
      });

      logger.error(errorToLog, {
        microserviceName: 'cian-chat-bot',
        pathApi: '/v1/save-poll-answers/',
        parameters: JSON.stringify(jsonQuery),
      });

      /* istanbul ignore next */
      dispatch(setFiltersLoading(false));
      /* istanbul ignore next */
      dispatch(showAlert({}));
    }
  };
